import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QbusTranslateService {
  private readonly translate = inject(TranslateService);


  async translateAll<T extends Record<string, string>>(items: T): Promise<T> {
    const promises = Object.entries(items).map(async ([key, value]) => {
      const translation = await firstValueFrom<string>(
        this.translate.get(value)
      );
      return [key, translation];
    });

    const result = await Promise.all(promises);
    return Object.fromEntries(result);
  }
}
